module.exports = __webpack_public_path__ + "img/3.0be81d2a.png";